<yc-modal
  [modalHeader]="'nonprofit:hdrAdditionalInformation' | ycI18n: 'Additional Information'"
  [cancelButtonText]="cancelButtonText"
  (onCancel)="_onClose()">
  <ng-container>
    <dl class="dl-horizontal">
      <dt>
        {{ attributeHdr }}
      </dt>
      <dd>
        {{ valueHdr }}
      </dd>
      <div class="separator"></div>
    </dl>
    <!-- REGISTERED NAME/ADDRESS  -->
    @if (registeredNameAndAddress) {
      <dl
        class="dl-horizontal">
        <dt>
          {{ NonprofitAdditionalInformationAttributesText.registeredNameAndAddress }}
        </dt>
        <dd>
          <div>{{ registeredNameAndAddress?.name }}</div>
          <div [innerHTML]="registeredNameAndAddress | address : false : true"></div>
        </dd>
        <div class="separator"></div>
      </dl>
    }
    <!-- DISBURSEMENT NAME/ADDRESS  -->
    <dl class="dl-horizontal">
      <dt>
        {{ NonprofitAdditionalInformationAttributesText.disbursementNameAndAddress }}
      </dt>
      <dd>
        @if (additionalInfo?.disbursementAddressIsRegisteredAddress) {
          <div>
            {{ sameNameAndAddressOnFiletext }}
          </div>
        }
        @if (!additionalInfo?.disbursementAddressIsRegisteredAddress) {
          <div>
            {{ disbursementNameAndAddress?.name  || noNameOnFiletext }}
          <div [innerHTML]="disbursementNameAndAddress?.address1 ?
            (disbursementNameAndAddress | address : false : true) :
            noAddressOnFiletext">
            </div>
          </div>
        }

      </dd>
      <div class="separator"></div>
    </dl>
    <!-- DISPLAY NAME/ADDRESS  -->
    <dl class="dl-horizontal">
      <dt>
        {{ NonprofitAdditionalInformationAttributesText.displayNameAndAddress }}
      </dt>
      <dd>
        @if (additionalInfo?.displayAddressIsRegisteredAddress) {
          <div>
            {{ sameNameAndAddressOnFiletext }}
          </div>
        }
        @if (!additionalInfo?.displayAddressIsRegisteredAddress) {
          <div>
            {{ displayNameAndAddress?.name || noNameOnFiletext }}
          <div [innerHTML]="displayNameAndAddress?.address1 ?
            (displayNameAndAddress | address : false : true) :
            noAddressOnFiletext">
            </div>
          </div>
        }
      </dd>
      <div class="separator"></div>
    </dl>
    <!-- EFG  -->
    @if (additionalInfo?.eligibleForGiving) {
      <dl
        class="dl-horizontal">
        <dt>
          {{ NonprofitAdditionalInformationAttributesText.eligibleForGiving }}
        </dt>
        <dd>
          {{ additionalInfo.eligibleForGiving | nppEligibleForGivingStatusIdPipe }}
        </dd>
        <div class="separator"></div>
      </dl>
    }
    <!-- ACH  -->
    <dl class="dl-horizontal">
      <dt>
        {{ NonprofitAdditionalInformationAttributesText.hasACH }}
      </dt>
      <dd>
        <div [innerHTML]="formatAttributeBoolean(additionalInfo?.hasACH)"></div>
      </dd>
      <div class="separator"></div>
    </dl>
    <!-- REG AUTH  -->
    @if (additionalInfo?.registrationAuthorityName) {
      <dl
        class="dl-horizontal">
        <dt>
          {{ NonprofitAdditionalInformationAttributesText.registrationAuthorityName }}
        </dt>
        <dd>
          {{ additionalInfo.registrationAuthorityName }}
        </dd>
        <div class="separator"></div>
      </dl>
    }
    <!-- IS ACTIVE  -->
    @if (additionalInfo?.isActive !== null) {
      <dl
        class="dl-horizontal">
        <dt>
          {{ NonprofitAdditionalInformationAttributesText.isActive }}
        </dt>
        <dd>
          <yc-i18n
          [key]="additionalInfo.isActive ?
            'common:textYes' :
            'common:textNo'">
          </yc-i18n>
        </dd>
        <div class="separator"></div>
      </dl>
    }
    <!-- ELIGIBLE FOR DISBURSEMENT -->
    @if (additionalInfo?.registrationAuthorityName) {
      <dl
        class="dl-horizontal">
        <dt>
          {{ NonprofitAdditionalInformationAttributesText.eligibleForDisbursement }}
        </dt>
        <dd>
          <yc-i18n
          [key]="!additionalInfo.disbursementSuspended ?
            'common:textYes' :
            'common:textNo'">
          </yc-i18n>
        </dd>
        <div class="separator"></div>
      </dl>
    }
    <!-- Created Date -->
    @if (additionalInfo?.createdDate) {
      <dl
        class="dl-horizontal">
        <dt>
          {{ NonprofitAdditionalInformationAttributesText.createdDate }}
        </dt>
        <dd>
          {{ additionalInfo.createdDate | ycFormatDate }}
        </dd>
        <div class="separator"></div>
      </dl>
    }

    <!-- CREATED BY USER -->
    @if (additionalInfo?.createdByUser) {
      <dl
        class="dl-horizontal">
        <dt>
          {{ NonprofitAdditionalInformationAttributesText.createdByUser }}
        </dt>
        <dd>
          {{ additionalInfo.createdByUser }}
        </dd>
        <div class="separator"></div>
      </dl>
    }

    <!-- WAS MANUAL ADDITION -->
    <dl class="dl-horizontal">
      <dt>
        {{ NonprofitAdditionalInformationAttributesText.isManualAdd }}
      </dt>
      <dd>
        <div [innerHTML]="formatAttributeBoolean(additionalInfo?.isManualAdd)"></div>
      </dd>
    </dl>
  </ng-container>
</yc-modal>